import { useState, type ReactNode } from 'react';
import { Badge, Button } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

interface Props {
  /** 第一列常駐的搜尋框（會自動撐滿剩餘寬度）。 */
  search: ReactNode;
  /** 已套用的篩選條件數（顯示在「篩選」按鈕的 Badge）。 */
  activeCount: number;
  /** 展開後的欄位，以兩欄 grid 排列；每個欄位請自行 `w-full`。 */
  children: ReactNode;
}

/**
 * 手機版可收合篩選面板：上方「搜尋 + 篩選按鈕」，按下才展開其餘條件。
 * 收合時只用 `hidden` 藏起來、不卸載——篩選欄位都是 uncontrolled，卸載會把已選的值清掉。
 */
export default function MobileFilterPanel({ search, activeCount, children }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-3 rounded-xl border border-black/5 bg-white p-2.5 shadow-sm">
      <div className="flex gap-2">
        <div className="min-w-0 flex-1">{search}</div>
        <Badge count={activeCount} size="small" color="#dd7900">
          <Button
            icon={<FilterOutlined />}
            type={open ? 'primary' : 'default'}
            ghost={open}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            篩選
          </Button>
        </Badge>
      </div>
      <div className={open ? 'mt-2 grid grid-cols-2 gap-2' : 'hidden'}>{children}</div>
    </div>
  );
}
